import { ISyncPublishResult } from '../controllers/DatasourcePublishResultCtrl';
import { Module } from '../Module';
import {
  IDatasourcePublishRemoteRefreshSelfServiceScheduleDialogScope,
  PublishDatasourceAction,
} from '../services/PublishDatasourceAction';

interface CreateDatasourceExtractRemoteRefreshSelfServiceScheduleScope extends IDatasourcePublishRemoteRefreshSelfServiceScheduleDialogScope {
  publishResult: ISyncPublishResult;
}

Module.instance().directive('tbDatasourceExtractRemoteRefreshSelfServiceScheduler',
  ['$translate',
    'PublishDatasourceAction',

    ($translate: ng.translate.ITranslateService,
      PublishDatasourceAction: PublishDatasourceAction) => {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          dataSourceDetail: '=',
          selfServiceSchedulePaneProps: '=',
          publishResult: '=',
          remoteAgentOptions: '=',
          scheduleInfo: '=',
          editModel: '=',
          availableTypeOptions: '='
        },
        templateUrl: 'datasourcePublishRemoteRefreshSelfServiceScheduleDialog.html',
        link: (scope: CreateDatasourceExtractRemoteRefreshSelfServiceScheduleScope) => {
          PublishDatasourceAction.remoteRefreshSelfServiceScheduleDialogScopeSetup(scope.publishResult, scope, false);
        }
      };
    }
  ]
);
